// import { instance } from '../helper/api'

export const get = async () => {
  // let resultData = []
  // const axiosConfig = {
  //   url: '/v1/storefront/landing-page/',
  //   method: 'GET'
  // }

  // try {
  //   const results = await instance.request(axiosConfig)
  //   resultData = results.data.data
  // } catch (error) {
  //   if (error.response) {
  //     return error.response.data
  //   } else {
  //     return error.message
  //   }
  // }

  return {
    product_categories: [],
    vendor_banner: [
      {
        banner_master: {
          id: 38,
          vendor_id: 258,
          name: '1',
          description: '',
          url: '94988',
          status: true,
          position: 1,
          created_at: '2025-01-24T20:08:05.393327Z',
          created_by: 451,
          updated_at: '2025-01-24T20:08:05.393327Z',
          updated_by: null
        },
        banner_images: [
          {
            id: 41,
            banner_id: 38,
            image: 'banners/1737724090.jpg',
            status: true,
            device_type: 'phone',
            created_at: '2025-01-24T20:08:11.004931Z',
            created_by: 451,
            updated_at: '2025-01-24T20:08:11.004931Z',
            updated_by: null
          }
        ]
      }
    ],
    vendor_shortcuts: [],
    vendor_setting_application: {
      id: 0,
      vendor_id: 0,
      android_version: 1,
      ios_version: 1,
      is_force_update: false,
      update_detail: '',
      apk: null,
      created_at: '0001-01-01T00:00:00Z',
      created_by: 0,
      updated_at: '0001-01-01T00:00:00Z',
      updated_by: null
    },
    setting: {
      is_fix_tax_product_checkout_active: false,
      shipping_tax_by_weight: 10000,
      is_shipping_tax_by_weight_checkout_active: false,
      shipping_tax_parameter_init: 1200,
      shipping_tax_parameter_multiple: 1000,
      is_maintenance: false,
      maintenance_detail: null,
      is_maximum_order_product_in_cart: true,
      maximum_order_product_in_cart: 20,
      is_maximum_order_qty_product_in_cart: true,
      maximum_order_qty_product_in_cart: 20,
      is_maximum_order_quantity_per_customer_in_cart: true,
      maximum_order_quantity_per_customer_in_cart: 1000
    },
    setting_cms: {
      id: 174,
      vendor_id: 258,
      is_show_category_in_header: true,
      is_show_navigation_in_header: true,
      is_show_category_in_body: true,
      is_show_banners: true,
      is_show_shorcuts: true,
      show_sub_category: 1,
      show_products_by: 1,
      show_categories_by: 1,
      is_show_variant_image: true,
      is_show_related_products: true,
      show_stock_product: 2,
      is_show_column_variant_one: true,
      is_show_column_variant_two: true,
      is_show_column_stock: true,
      is_show_out_of_stock_variant_product: true,
      is_show_out_of_stock_product: true,
      is_show_checkout_deadline_time_information: false,
      is_show_checkout_button: true,
      is_show_pay_on_spot_button: true,
      checkout_button_text: 'Checkout',
      pay_on_spot_button_text: 'Pay on Spot',
      view_detail_product_variant: 1,
      join_column_color_size_stock: false,
      created_at: '2025-01-15T14:00:33.316408Z',
      created_by: 451,
      updated_at: '2025-01-16T20:51:47.609576Z',
      updated_by: 451,
      is_show_brands: false
    },
    setting_customer: {
      id: 172,
      vendor_id: 258,
      is_customer_required_login: true,
      is_regist_need_confirm: true,
      phone_activations: '6281806645256',
      phone_services: '6281806645256',
      details_inactive_status: 'Account need activations admin',
      created_at: '2025-01-15T14:00:33.218063Z',
      created_by: 451,
      updated_at: '2025-01-16T21:02:25.775379Z',
      updated_by: 451
    },
    maintenance_detail: {
      is_web_maintenance: false,
      is_android_maintenance: false,
      is_ios_maintenance: false,
      maintenance_text: null
    }
  }
}
